module.exports = __webpack_public_path__ + "img/Background_LMS.bb068b34.png";